import { defineStore } from "pinia";
import { organizationTreeApi,organizationTreeApi1 } from "@/api/api";
import { ElMessage } from "element-plus";
import { getCurrentInstance } from "vue";
export const useMain = defineStore("main", {
  // 相当于data
  state: () => {
    return {
      recordRouterList:
        JSON.parse(sessionStorage.getItem("recordRouterList") || "[]") || [],
      marketList: [] as any[],
      unreadNum: {},
      deviceType: navigator.userAgent.indexOf("Mobile") > -1 ? "mobile" : "web",
      menuPosition: true,// 新的在上方
      searchPosition: false,// 搜索框位置
    };
  },
  getters: {
    getRecordRouterList(state) {
      return state.recordRouterList;
    },
    getMarketList(state) {
      return state.marketList;
    },
  },
  actions: {
    setRecordRouterList() {
      const data =
        JSON.parse(sessionStorage.getItem("recordRouterList") || "[]") || [];
      this.recordRouterList = data;
    },
    setUnReadNum(val: object) {
      this.unreadNum = val;
    },
    setMenuPosition(val: boolean) {
      this.menuPosition = val;
    },
    setSearchPosition(val: boolean) {
      this.searchPosition = val;
    },
  },
});

export const useUnit = defineStore("unit", {
  state: () => {
    return {
      treeData: [] as any[],
      treeData1: [] as any[],//搜索排序勾选在上面
    };
  },
  actions: {
    async initTreeData(app:any,other:Object={}) {
      const id =
        app?.$app.loginUserType == 0
          ? 0
          : app?.$app.loginUserType == 1
          ? app.$app.merchantId
          : app?.$app.organizeId;
      const params = {
        id:id||0,
        type:app?.$app.loginUserType || 0,
        ...other
      };
      const res = await organizationTreeApi(
        params
      );
      if (res.code == 200) {
        this.treeData = [];
        this.treeData.push(res.data);
      } else {
        this.treeData = [];
        ElMessage.error(res.message);
      }
    },
    async initTreeData1(app:any,other:Object={}) {
      const id =
        app?.$app.loginUserType == 0
          ? 0
          : app?.$app.loginUserType == 1
          ? app.$app.merchantId
          : app?.$app.organizeId;
      const params = {
        id:id||0,
        type:app?.$app.loginUserType || 0,
        ...other
      };
      const res = await organizationTreeApi1(
        params
      );
      if (res.code == 200) {
        this.treeData1 = [];
        this.treeData1.push(res.data);
      } else {
        this.treeData1 = [];
        ElMessage.error(res.message);
      }
    },
  },
});
